/**
 * Layout dimensions for the report editor
 */
export const DIMENSIONS = {
  // Sidebar dimensions
  SIDEBAR_EXPANDED_WIDTH: 280,
  SIDEBAR_COLLAPSED_WIDTH: 60,

  // Content panel dimensions
  CONTENT_PANEL_WIDTH: 476,

  // Iframe rendering dimensions
  TOP_MARGIN: 10,
  SIDE_MARGIN: 20,
  ACTION_BOX_WIDTH: 56,

  // Heights
  STEP_HEIGHT: 44,
  HEADER_HEIGHT: 57,

  // Icon sizes
  ICON_SIZE: 20,

  // Page dimensions
  PAGE_WIDTH: 794,
  PAGE_HEIGHT: 1123,
};

/**
 * Animation durations and timing functions
 * Matches MUI standard transition from main sidebar (layout.tsx)
 */
export const ANIMATIONS = {
  TRANSITION_DURATION: '225ms',
  TRANSITION_TIMING: 'cubic-bezier(0.4, 0, 0.6, 1)',
  FADE_DURATION: '225ms',
  CROSSFADE_MS: 150,
};

/**
 * Z-index values
 */
export const Z_INDEX = {
  OVERLAY: 10,
  DROPDOWN: 1000,
};
